module.exports = __webpack_public_path__ + "img/accessory_hat_02.95e5f8b0.svg";